/* TWRD slide progress. Shared painter for .twrd-progress indicators, plus the
   binding for Swiper carousels (homepage slideshow).

   Swiper sync: Swiper 11 emits `autoplayTimeLeft(swiper, timeLeft, ratio)` on
   every frame while autoplay runs (ratio = time left / delay, 1 -> 0). The
   fill is 1 - ratio, so it follows the real timer, its pauses (tab hidden,
   focus, touch) and its restarts after manual navigation. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function reducedMotion() {
    return Boolean(reduce && reduce.matches);
  }

  function clamp(value) {
    if (!(value > 0)) return 0;
    return value > 1 ? 1 : value;
  }

  function setProgress(container, value) {
    if (!container) return;
    container.style.setProperty('--twrd-p', clamp(value).toFixed(4));
  }

  /* Mark segments before the active one as past. */
  function paint(container, activeIndex) {
    if (!container) return;
    var segs = container.children;
    for (var i = 0; i < segs.length; i += 1) {
      segs[i].classList.toggle('is-past', i < activeIndex);
    }
  }

  function bindSwiper(carousel) {
    if (!carousel || carousel.dataset.twrdProgressBound === '1') return;
    var slider = carousel.querySelector('media-carousel-slider');
    var container = carousel.querySelector('[data-twrd-progress]');
    var swiper = slider && slider.swiper;
    if (!swiper || !container || swiper.destroyed) return;
    carousel.dataset.twrdProgressBound = '1';

    var timed = Boolean(swiper.params.autoplay && swiper.params.autoplay.enabled);

    function index() {
      return swiper.params.loop ? swiper.realIndex : swiper.activeIndex;
    }

    function refresh() {
      paint(container, index());
      container.classList.toggle('is-timed', timed && !reducedMotion());
    }

    swiper.on('autoplayTimeLeft', function (s, timeLeft, ratio) {
      setProgress(container, 1 - ratio);
    });
    swiper.on('slideChange', function () {
      setProgress(container, 0);
      refresh();
    });
    swiper.on('paginationRender paginationUpdate', refresh);
    swiper.on('autoplayStop', function () {
      timed = false;
      refresh();
    });
    swiper.on('autoplayStart', function () {
      timed = true;
      refresh();
    });
    swiper.on('destroy', function () {
      carousel.dataset.twrdProgressBound = '';
    });

    setProgress(container, 0);
    refresh();
  }

  function bootSwipers(root) {
    var carousels = (root || document).querySelectorAll('media-carousel[data-twrd-progress-host]');
    Array.prototype.forEach.call(carousels, function (carousel) {
      bindSwiper(carousel);
      if (carousel.dataset.twrdProgressListen === '1') return;
      carousel.dataset.twrdProgressListen = '1';
      /* Swiper starts when the carousel scrolls into view. */
      carousel.addEventListener('on:media-carousel:init', function () {
        bindSwiper(carousel);
      });
    });
  }

  window.TwrdSlideProgress = {
    paint: paint,
    setProgress: setProgress,
    reducedMotion: reducedMotion,
    bootSwipers: bootSwipers
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootSwipers();
    });
  } else {
    bootSwipers();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootSwipers(event.target);
  });
})();
